export default "__VITE_ASSET__BJTKHdU2__"